import { featureImageSize } from "../const";
import {
  cardTitle,
  container,
  primaryColor,
  secondaryColor,
  tertiaryColor,
  tertiaryColorTint,
  title
} from "../../nextjs-material-kit.js";
import imagesStyles from "../imagesStyles";

/**
 * Currently used for article detail page, article list component used on `/news` and `/advice`, and some old demos.
 */
const articleStyle = (theme) => ({
  container: {
    zIndex: "12",
    height: "auto",
    margin: "0 auto !important",
    marginBottom: "0",
    ...container(theme),
  },
  title: {
    ...title,
    textAlign: "center",
    position: "relative",
    marginTop: "30px !important",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "5.5em",
  },
  inputField: {
    border: "1px solid #a4b9c2",
  },
  search_section: {
    margin: "0 auto 0", // Give the arrow decoration visible space without this overlapping.
    padding: "10px 20px",
    maxWidth: "500px",
    background: "#095A70",
    color: "#ffffff",
    opacity: 0.86,
  },
  homeSearchButton: {
    fontSize: "18px",
    marginTop: "0",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 700,
    textTransform: "none",
    backgroundColor: tertiaryColor,
    marginBottom: "0px",
    lineHeight: "16px",
    display: "flex",
    boxShadow: "none",
    padding: "6.5px 30px",
    "&:hover": {
      backgroundColor: tertiaryColorTint,
    },
  },
  section: {
    padding: "30px 0 70px",
  },
  primaryColor: {
    backgroundColor: "#095a70",
    marginLeft: "-15px",
    marginTop: "15px",
  },
  cardTitlePurple: {
    color: "#683f8c !important",
    fontSize: "26px",
    marginTop: 0,
    marginBottom: "2px !important",
  },
  purple: {
    fontWeight: 600,
    backgroundColor: "#683f8c !important",
  },
  lightGrey: {
    display: "flex",
    backgroundColor: "#f9f7fa",
    marginBottom: "18px",
  },
  cardDesc: {
    color: "#000",
    fontSize: "16px",
    lineHeight: "1.1",
    paddingRight: "8%",
    marginBottom: 0,
  },
  ...imagesStyles,
  imgContainer: {
    display: "flex",
    padding: "10px",
  },
  imgContainerFull: {
    display: "flex",

    img: {
      display: "block",
      maxHeight: "100%",
      objectFit: "cover",
      height: "100%",
    },
  },
  imgFluid: {
    ...imagesStyles.imgFluid,
    objectFit: "contain",
    alignSelf: "center", // Allow mobile horizontal centring inside flex container, without stretching.
    maxHeight: featureImageSize,
    maxWidth: "unset",
    marginTop: "0", // override 10px from imagesStyles

    "@media (max-width: 768px)": {
      marginTop: "10px",
    },
  },
  advert: {
    margin: "0 auto 30px",
    width: "100%",
    textAlign: "center",
  },
  itemGrid: {
    height: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  noMargin: {
    padding: "0px !important",
  },
  smallTitle: {
    color: "#6c757d",
  },
  description: {
    color: "#000",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: "100 !important",
    textAlign: "left",
  },
  inlineBlock: {
    display: "inline-block",
  },
  justifyCenter: {
    justifyContent: "center !important",
  },
  floatLeft: {
    float: "left",
  },
  padding5: {
    padding: "5px 10px",
  },
  padding10: {
    padding: "10px 20px",
  },
  centred: {
    textAlign: "center",
    width: "auto",
  },
  detailSection: {
    margin: "auto",
    "@media (max-width: 768px)": {
      maxWidth: "100%",
    },
  },
  readAllBtn: {
    width: "100%",
  },
  readMoreBtn: {
    fontSize: "16px",
    marginTop: "1rem",

    marginBottom: "14px",
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
  readMoreLink: {
    display: "block",
    fontWeight: 700,
    color: "#683f8c !important",
    fontSize: "16px",
    marginTop: "1rem",
  },
  cardTitle: {
    ...cardTitle,
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    textAlign: "left",
    color: "#095A70",
    fontSize: "60px",
    paddingLeft: "0px",
    margin: "0 !important",
  },
  cardTitle2: {
    color: "#095a70",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "60px",
    textAlign: "left",
    left: "0%",
    marginTop: '0 !important',
    transform: "translateX(0%)",
  },
  cardSubTitle: {
    margin: 0,
    color: "#000",
    fontFamily: "var(--font-brandon-grotesque)",
    textAlign: "left",
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0",
  },
  main: {
    position: "relative",
    zIndex: "3",
  },
  bg_colored: {
    backgroundColor: "#eaf6fe",
  },
  darkBlue: {
    // backgroundColor: "#095a70 !important",
    backgroundColor: primaryColor,
  },
  lightGreen: {
    backgroundColor: secondaryColor,
    paddingTop: "7px",
    paddingBottom: "8px",
    marginTop: "22px",
  },
  colored_bg: {
    background: "#eaf6fe",
    padding: "50px 0",
    minHeight: "280px",
  },
  white_bg: {
    background: "#ffffff",
  },
  pageInfo: {
    color: "#000",
    fontSize: "80%",
  },
  jobSidebar: {
    paddingTop: '0.75rem',
  }
});

export default articleStyle;
